export const breakpoints = {
  xs: 320,
  sm: 480,
  md: 768,
  lg: 1025,
  xl: 1200,
};
